import { AxiosError } from 'axios'
import { removeOrder } from './ApiService'
import { DeleteOrderDto } from '../types/swaggerTypes'

// Orders this browser session has already deleted successfully.
const deletedOrderNumbers = new Set<string>()

const ALREADY_DELETED_STATUSES = [400, 404]

/**
 * Deletes an order, treating a repeat delete of an order this session already
 * deleted as success. Oracle answers a second DELETE with 400/404, which used
 * to surface as an error after a partially completed delete/cancel and made
 * users retry again (PROD CLOS-14579).
 */
export const removeOrderOnce = async (
  orderNumber: string,
  deleteReason: DeleteOrderDto
): Promise<void> => {
  const key = String(orderNumber)
  try {
    await removeOrder(key, deleteReason)
    deletedOrderNumbers.add(key)
  } catch (error) {
    const status = (error as AxiosError)?.response?.status
    if (
      deletedOrderNumbers.has(key) &&
      status !== undefined &&
      ALREADY_DELETED_STATUSES.includes(status)
    ) {
      return
    }
    throw error
  }
}

/** Test helper: forget orders deleted in this session. */
export const resetDeletedOrdersForTests = () => deletedOrderNumbers.clear()
